import Modal from 'react-modal';
import { useState } from "react"
import useKeypress from "../ownHooks/pressEsc";
import { FehlerauswertungErrResp } from '../Fehler/FehlerauswertungErrResp';
import { MyModalButtons, MyModalCloseButton, MyModalContentDateInput, MyModalContentRow, MyModalContentTextInput, MyModalForm } from '../StyleSheets/ModalStyle';
import { MyCancelButton, MySaveButton } from '../StyleSheets/GeneralButtonStyles';

var MonitorApi = require('monitor-api');


export default function VlpUpdate({ rowEntry, reloadData, vlpInstance }) {
    const [showModal, setShowModal] = useState(false);
    const [newUpdates, setNewUpdates] = useState(new MonitorApi.VertraglinieproduktUpdate());
    const [upAvailable, setUpAvailable] = useState(false);
    const [myComment, setMyComment] = useState('');

    const translateStringToDate = (dateString) => {
        if (dateString === null) {
            return;
        }
        var arr = dateString.split(".");
        var mm = arr[1].length === 2 ? arr[1] : '0' + arr[1];
        var dd = arr[0].length === 2 ? arr[0] : '0' + arr[0];
        return arr[2] + "-" + mm + "-" + dd;
    }

    const [inputs, setInputs] = useState({});

    const [classes, setClasses] = useState({});
    const resetClasses = () => {
        setClasses({
            gueltigVon: "unchanged",
            gueltigBis: "unchanged",
            kommentar: "unchanged"
        });
    }
    const openModal = event => {
        console.log(rowEntry.original)
        setInputs({
            vertrag: rowEntry.original.vv,
            linie: rowEntry.original.linie,
            gueltigVon: translateStringToDate(rowEntry.original.gueltigVon),
            gueltigBis: translateStringToDate(rowEntry.original.gueltigBis),
            // kommentar: rowEntry.original.kommentar
        });
        setMyComment(rowEntry.original.kommentar);
        setShowModal(true);
        setNewUpdates(pre => ({ ...pre, vlpId: rowEntry.original.vlpId }));
        resetClasses();
        setUpAvailable(false);
    }

    const closeModal = event => {
        setNewUpdates({ 'gueltigVon': undefined, 'gueltigBis': undefined });
        setShowModal(false);
    }

    useKeypress('Escape', () => {
        closeModal();
    });

    const addUpdates = e => {
        console.log(newUpdates)
        setNewUpdates(pre => ({ ...pre, [e.target.id]: e.target.value }));
        if (e.target.id === 'kommentar') {
            setMyComment(e.target.value);
        }
        setClasses(pre => ({ ...pre, [e.target.id]: "changed" }));
        setUpAvailable(true);
    }


    const saveChanges = (event) => {
        event.preventDefault();
        if (newUpdates.gueltigVon && newUpdates.gueltigBis) {
            if (newUpdates.gueltigVon > newUpdates.gueltigBis) {
                alert("Fehler: Gültigkeitsbeginn liegt nach Gültigkeitsende!")
                return;
            }
        }
        if (newUpdates.gueltigVon === "") {
            setNewUpdates(pre => ({ ...pre, "gueltigVon": undefined }))
        }

        if (newUpdates.gueltigBis === "") {
            setNewUpdates(pre => ({ ...pre, "gueltigBis": undefined }))
        }

        console.log(newUpdates)

        vlpInstance.patchDatesOfVlp(newUpdates, (error, data, response) => {
            if (error) {
                FehlerauswertungErrResp(error, response);
            } else {
                reloadData();
                closeModal();
                alert(`Änderungen gespeichert`);
            }
        })
    }

    return (
        <>
            <button onClick={openModal} className="update-bttn" style={{ width: '17em' }} >Gültigkeiten bearbeiten</button>
            <Modal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm>
                    <h3>Ändern der Gültigkeiten</h3>
                    <h5>Für Vertrag {inputs.vertrag} ({inputs.linie})</h5>
                    <MyModalContentRow>
                        <label>Gültigkeitsbeginn ({inputs.gueltigVon}):
                            <MyModalContentDateInput id="gueltigVon"
                                value={newUpdates.gueltigVon ? newUpdates.gueltigVon : inputs.gueltigVon}
                                onChange={addUpdates}
                                max={newUpdates.gueltigBis ? newUpdates.gueltigVon : inputs.gueltigBis}
                                className={classes.gueltigVon} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Gültigkeitsende {inputs.gueltigBis ? `(${inputs.gueltigBis})` : ""}:
                            <MyModalContentDateInput id="gueltigBis"
                                value={newUpdates.gueltigBis ? newUpdates.gueltigBis : inputs.gueltigBis}
                                onChange={addUpdates}
                                min={newUpdates.gueltigVon ? newUpdates.gueltigVon : inputs.gueltigVon}
                                className={classes.gueltigBis} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Kommentar:
                            <MyModalContentTextInput id="kommentar"
                                value={myComment}
                                onChange={addUpdates}
                                className={classes.kommentar} />
                        </label>
                    </MyModalContentRow>
                    <MyModalButtons>
                        <MySaveButton type="submit" disabled={!upAvailable} onClick={saveChanges}>Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbruch</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
                <p>{JSON.stringify(newUpdates)}</p>
            </Modal>
        </>
    )
}